import { http, Result } from "@fider/services/http"
import { PostOwner } from "@fider/models"

export const createPostOwner = async (name: string, color: string, icon: string): Promise<Result<PostOwner>> => {
  return http.post<PostOwner>(`/api/v1/owners`, { name, color, icon }).then(http.event("postowner", "create"))
}

export const updatePostOwner = async (slug: string, name: string, color: string, icon: string): Promise<Result<PostOwner>> => {
  return http.put<PostOwner>(`/api/v1/owners/${slug}`, { name, color, icon }).then(http.event("postowner", "update"))
}

export const deletePostOwner = async (slug: string, reassignToSlug?: string): Promise<Result> => {
  return http.delete(`/api/v1/owners/${slug}`, { reassignToSlug }).then(http.event("postowner", "delete"))
}
